import { FC } from "react";

interface DashboardsProps {
  isCollapsed: boolean;
}

export const Dashboards: FC<DashboardsProps> = () => null;
